import { FC } from "react";

interface InstagramIconSVGProps {
    className?: string;
    stroke?: string;
}

const InstagramIconSVG: FC<InstagramIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.17994 1.44043C4.73953 1.44043 1.93994 4.24002 1.93994 7.68043V16.3204C1.93994 19.7608 4.73953 22.5604 8.17994 22.5604H16.8199C20.2603 22.5604 23.0599 19.7608 23.0599 16.3204V7.68043C23.0599 4.24002 20.2603 1.44043 16.8199 1.44043H8.17994ZM8.17994 2.40043H16.8199C19.7415 2.40043 22.0999 4.75892 22.0999 7.68043V16.3204C22.0999 19.2419 19.7415 21.6004 16.8199 21.6004H8.17994C5.25843 21.6004 2.89994 19.2419 2.89994 16.3204V7.68043C2.89994 4.75892 5.25843 2.40043 8.17994 2.40043ZM18.2599 5.28043C18.0053 5.28043 17.7612 5.38157 17.5811 5.56161C17.4011 5.74164 17.2999 5.98582 17.2999 6.24043C17.2999 6.49504 17.4011 6.73922 17.5811 6.91925C17.7612 7.09929 18.0053 7.20043 18.2599 7.20043C18.5145 7.20043 18.7587 7.09929 18.9388 6.91925C19.1188 6.73922 19.2199 6.49504 19.2199 6.24043C19.2199 5.98582 19.1188 5.74164 18.9388 5.56161C18.7587 5.38157 18.5145 5.28043 18.2599 5.28043ZM12.4999 6.72043C9.58956 6.72043 7.21994 9.09005 7.21994 12.0004C7.21994 14.9108 9.58956 17.2804 12.4999 17.2804C15.4103 17.2804 17.7799 14.9108 17.7799 12.0004C17.7799 9.09005 15.4103 6.72043 12.4999 6.72043ZM12.4999 7.68043C14.8915 7.68043 16.8199 9.60887 16.8199 12.0004C16.8199 14.392 14.8915 16.3204 12.4999 16.3204C10.1084 16.3204 8.17994 14.392 8.17994 12.0004C8.17994 9.60887 10.1084 7.68043 12.4999 7.68043Z"
                fill="black"
            />
        </svg>
    );
};

export default InstagramIconSVG;
